import { Box, Text } from '@medely/ui-kit';
import React from 'react';

export const TaxableModalInfo = () => {
  return (
    <>
      <Box pb={2} testId="taxable-modal">
        <Text size="l" textAlign="justify">
          Medely has partnered with Frontline Health to offer a W2 option to Medely professionals.
        </Text>
      </Box>
      <Box pb={2}>
        <Text size="l" textAlign="justify">
          This is how much in wages you’ll make for working all Contracted Hours every week. The
          simplest way to calculate this is by multiplying your Base Rate and your Contracted Hours.
          In some situations, your Contracted Hours include some Overtime. If so, we’ve determined
          how many hours you’ll be paid Overtime and added that to the weekly total.
        </Text>
      </Box>
      <Box pb={2}>
        <Text size="l" textAlign="justify">
          Since you can expect this amount of income each week, we take the total wages and divide
          them by the contracted rate to determine the contracted Hourly Rate which should give you
          a good idea of the minimum hourly wages you’ll make each hour of this contract.
        </Text>
      </Box>
      <Text size="l" textAlign="justify">
        This rate is based on your Contracted Hours and may change as you work extra hours, shifts
        with different rates, and more.
      </Text>
    </>
  );
};
